module.exports = __webpack_public_path__ + "img/diag_icon.873315f9.svg";